import { Box, Button, Typography } from "@mui/material";
import { ModalsKeys } from "global";
import { useModal } from "hooks/useModal";
import { ReactNode } from "react";
import { SendInsuranceQuoteDialog } from "./dialogs/sendInsuranceQuoteDialog/SendInsuranceQuoteDialog";
import { ModalsContainer } from "components/shared/Modals";

export const InsuranceHeader = () => {
  const { handleOpen: openSendInsuranceQuoteModal } = useModal(ModalsKeys.SendInsuranceQuoteDialog);

  const modalsWithKeys: Partial<Record<ModalsKeys, ReactNode>> = {
    [ModalsKeys.SendInsuranceQuoteDialog]: <SendInsuranceQuoteDialog />,
  };

  return (
    <Box display="flex" justifyContent="space-between">
      <Typography variant="h6" component="p">
        Insurance
      </Typography>
      <Button
        size="small"
        color="primary"
        onClick={() => {
          openSendInsuranceQuoteModal();
        }}>
        Send insurance quote
      </Button>

      <ModalsContainer modalsWithKeys={modalsWithKeys} />
    </Box>
  );
};
